export default function IconApproveCheck(props) {
  return (
    <svg width="9" height="9" viewBox="0 0 10 8" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="1,4 4,7 9,1"/>
    </svg>
  )
}
